import { ICaptionsHOCProps } from '../../../../../CaptionsContainer/Captions/hocs/types';
import { IState } from '../../../../../../store/types';
import { ICaptionsEvents, ICaptionsFields } from '../../../../../CaptionsContainer/Captions/components/types';
import { getNativeCaptions, getTargetCaptions, isVideoCaptionsEmpty } from '../../../../../../store/videos/selectors';
import {
  getAudioPlayerState,
  getAuthUser,
  getAutoPause,
  getAutoSync,
  getMainViewMode,
  getShowNativeCaptionsIfAvailable,
  getUseShortcuts,
  isHoverAutoPause,
  isPauseOnNote,
  isShowNativeLanguageTooltip
} from '../../../../../../store/general/selectors';
import { EAuthUserRole, EMainViewMode, EUserGroupType } from '../../../../../../store/general/types';
import {
  getActiveGroupId,
  getActiveGroupNativeLanguage,
  getActiveGroupTargetLanguage, getAudioById, getUserGroupById
} from '../../../../../../store/models/selectors';
import { RecordingsEffects } from '../../../../../../effects/recordingsEffects';
import {
  getCurrentAudioId,
  getCurrentMovieKey,
  getSelectedNativeCaption,
  getSelectedTargetCaption
} from '../../../../../../store/current-video/selectors';
import { connect } from 'react-redux';
import { AudioCaptionsContainer } from '../components/AudioCaptionsContainer';
import { AudioCaptionsContainerEvents } from './events';
import { CaptionsEvents } from '../../../../../CaptionsContainer/Captions/hocs/events';

const mapStateToProps = (
  dispatch: any,
  {}: ICaptionsHOCProps
) => {
  return (
    state: IState
  ): ICaptionsFields => {
    const targetCaptions = getTargetCaptions(state);
    const nativeCaptions = getNativeCaptions(state);
    const showNativeLangTooltip = (!!targetCaptions.length || !!nativeCaptions.length) && isShowNativeLanguageTooltip(state);

    const showNativeCaptions = getShowNativeCaptionsIfAvailable(state)
      getMainViewMode(state) !== EMainViewMode.PHRASES;

    const captionsEmpty = isVideoCaptionsEmpty(state);

    const groupTargetLangName = getActiveGroupTargetLanguage(state)?.name || '';
    const groupNativeLangName = getActiveGroupNativeLanguage(state)?.name || '';

    const isShowNativeCaptionsAvailable = !!nativeCaptions.length;
    const hoverAutoPause = isHoverAutoPause(state);
    const autoPause = !!getAutoPause(state);
    const autoPauseNotes = isPauseOnNote(state);
    const useShortcuts = getUseShortcuts(state);
    const isReview = getMainViewMode(state) === EMainViewMode.PHRASES;

    const isAdmin = getAuthUser(state)?.role === EAuthUserRole.ADMIN;
    const audioId = getCurrentAudioId(state);
    const audio = getAudioById(state, audioId);
    const isConferenceGroup = getUserGroupById(state, getActiveGroupId(state) || 0)?.type === EUserGroupType.CONFERENCE;
    const roomName = isConferenceGroup ? RecordingsEffects.getRoomIdForAudio(audio) : '';

    return {
      playerState: getAudioPlayerState(state),
      targetCaptions,
      nativeCaptions,
      captionsEmpty,
      targetLang: getSelectedTargetCaption(state)?.code,
      nativeLang: getSelectedNativeCaption(state)?.code,
      autoSync: getAutoSync(state),
      groupId: getActiveGroupId(state) || 0,
      videoId: getCurrentMovieKey(state),
      showNativeLangTooltip,
      showNativeCaptions,
      groupTargetLangName,
      groupNativeLangName,
      isShowNativeCaptionsAvailable,
      hoverAutoPause,
      autoPause,
      autoPauseNotes,
      useShortcuts,
      isReview,
      isAdmin,
      audioId,
      roomName,
    }
  };
}

const mapDispatchToProps = (
  dispatch: any
): ICaptionsEvents => ({
    onKeyDown: () => dispatch(AudioCaptionsContainerEvents.onKeyDown()),
    onVideoChange: () => dispatch(AudioCaptionsContainerEvents.onVideoChange()),
    onTargetCaptionsChange: () => dispatch(AudioCaptionsContainerEvents.onTargetCaptionsChange()),
    onNativeCaptionsChange: () => dispatch(AudioCaptionsContainerEvents.onNativeCaptionsChange()),
    onShowNativeCaptionsChange: () => dispatch(CaptionsEvents.onShowNativeCaptionsChange()),
    onHoverAutoPauseChange: () => dispatch(CaptionsEvents.onHoverAutoPauseChange()),
    onAutoPauseChange: () => dispatch(CaptionsEvents.onAutoPauseChange()),
    onAutoPauseNotesChange: () => dispatch(CaptionsEvents.onAutoPauseNotesChange()),
    onTargetCaptionIndexChange: index => dispatch(CaptionsEvents.onTargetCaptionIndexChange(index)),
    onToggleShortcuts: () => dispatch(CaptionsEvents.onToggleShortcuts()),
  }
);

export const AudioCaptionsContainerHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioCaptionsContainer);

AudioCaptionsContainerHOC.displayName = 'AudioCaptionsContainerHOC';
